import { useDispatch } from "react-redux";
import { fetchOfficeByCampusId, getTicket } from "../../pages/actions/actions";
import { errorFormate } from "../../utils/helper";
import { ShowAlert } from "../../utils/showAlert";
import { UseGetStoreData } from "../getStoreData/UseGetStoreData";
import { useNavigate } from "react-router-dom";
import { skipToken, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { getAmbulanceTrips } from "../../http";
import {
  ambulanceTripStart,
  setAmbulanceTripData,
  ambulanceTripFailure,
} from "../../redux/ambulanceTripSlice/ambulanceTripSlice";


export const useGetTicketData = ({ id }: any) => {

  const { getTicketData: isTicketDataPresent } = UseGetStoreData();
  const { getTicketData } = UseGetStoreData()
  const dispatch = useDispatch();
  const navigate = useNavigate();



  useEffect(() => {
    if (getTicketData?.campusId) {
      fetchOfficeByCampusId({ campusId: getTicketData.campusId, dispatch });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getTicketData?.campusId]);

  // Fetch and store the active hospital-service ambulance trip whenever the
  // current ticket changes so the whole app can read trip data from the store.
  useEffect(() => {
    const ticketId = getTicketData?._id;
    if (!ticketId) return;
    dispatch(ambulanceTripStart());
    getAmbulanceTrips({ ticketId: ticketId.toString() })
      .then((res) => {
        const trips: any[] = res.data?.data ?? [];
        const active = trips.find(
          (t: any) => t.serviceStatus !== "Completed" && t.serviceStatus !== "Cancelled"
        );
        dispatch(setAmbulanceTripData(active ?? null));
      })
      .catch(() => dispatch(ambulanceTripFailure()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getTicketData?._id]);


  const getTicketTicketId = async (ticketId: string) => {

    try {
      return await getTicket({ ticketId, navigate, dispatch });
    } catch (e) {
      ShowAlert("warning", errorFormate({ e, service: "getTicket" }));
    }
  };
  const shouldFetch = id
    ? !isTicketDataPresent || isTicketDataPresent._id !== +id
    : navigate("/");
  const { data, isLoading, isError } = useQuery({
    queryKey: ["ticket", id],
    queryFn: shouldFetch ? () => getTicketTicketId(id || "1") : skipToken,
  });

  return { shouldFetch, data, isLoading, isError }
}